import { createTheme as createMuiTheme } from '@mui/material';
import { ptBR as corePtBR } from '@mui/material/locale';
import { ptBR as dpPtBR } from '@mui/x-date-pickers/locales';

import shadows from './shadows';
import typography from './typography';
import { createPalette } from './palette';

export function createTheme() {
  const palette = createPalette();
  return createMuiTheme(
    {
      palette,
      shadows,
      typography,
      components: {
        MuiCheckbox: {
          styleOverrides: {
            root: {
              color: palette.weesu.dark_blue,
            },
          },
        },
        MuiLinearProgress: {
          styleOverrides: {
            root: {
              borderRadius: '5px',
            },
            barColorPrimary: {
              backgroundColor: palette.weesu.light_blue,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              ':hover:not($disabled)': {
                backgroundColor: palette.background.default,
              },
            },
            input: {
              padding: '11.5px 10px',
            },
          },
        },
        MuiBreadcrumbs: {
          styleOverrides: {
            separator: {
              marginLeft: 8,
              marginRight: 2,
            },
          },
        },
      },
      zIndex: {
        appBar: 1200,
        drawer: 1100,
      },
    },
    corePtBR,
    dpPtBR
  );
}
